import { render, staticRenderFns } from "./SfTableData.vue?vue&type=template&id=29be63d6&"
import script from "./SfTableData.vue?vue&type=script&lang=js&"
export * from "./SfTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports